import { ReactNode } from 'react'
import { FlightContainer as FlightContainerComponent } from './flightContainer'

interface FlightContainerProps {
    children: ReactNode
    isHeya?: boolean,
    hideGradient?: boolean
}

export const FlightContainer = ({ children, isHeya, hideGradient }: FlightContainerProps) => {
    return <FlightContainerComponent isHeya={isHeya} hideGradient={hideGradient} >{children}</FlightContainerComponent>

}
